import { useQuery } from "@tanstack/react-query";
import ConfigHolder from "../../config/ConfigHolder";
import useWidgetStore from "../../store/useWidgetStore";
import { useSettings } from "../../context/SettingsContext";
/**
 * The appointments the signed in consumer has with this company, past and future.
 *
 * This is the consumer's own appointment list (/consumer/appointment/list) in the widget: the
 * backend selects and splits them, so the two lists arrive ready to show, and each appointment
 * already carries whether the consumer may still cancel or reschedule it.
 *
 * The consumer is the one in the store, and is sent as the token the sign in returned - the
 * widget never asks the API for the appointments of a consumer id. Without a signed in consumer
 * there is nothing to ask for, so the query does not run.
 */
export const useConsumerAppointments = (options) => {
    const { api_key, widget_id } = useSettings();
    const { consumer } = useWidgetStore();
    const defaultOptions = Object.assign(Object.assign({}, options), { enabled: !!(consumer === null || consumer === void 0 ? void 0 : consumer.id), networkMode: "always", cacheTime: 0, staleTime: 0 });
    return useQuery(Object.assign(Object.assign({}, defaultOptions), { queryKey: ['widget-consumer-appointments', consumer === null || consumer === void 0 ? void 0 : consumer.id], queryFn: async ({ signal }) => {
            var _a;
            let url = ConfigHolder.getApiMethodUrl(api_key, widget_id, 'appointments', 'consumer');
            let data = {
                consumerId: (_a = consumer === null || consumer === void 0 ? void 0 : consumer.id) !== null && _a !== void 0 ? _a : ''
            };
            const response = await fetch(url.href, {
                signal: signal,
                method: "POST",
                headers: {
                    'Content-Type': 'application/json', // checks this header if it's a POST, while calling the method getRestData.... That's not Restful
                    'X-OAnl-csrf-protection': 'on',
                    'accept': 'application/json+ld',
                },
                body: JSON.stringify(data)
            });
            return response.json();
        } }));
};
